import { toast } from "react-toastify";

import { SyncFunctionCampaignsResponseBodyType } from "@intelligems/ig-types";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api";

const syncAppDiscountFunctions = async () => {
  const resp = await api.get<SyncFunctionCampaignsResponseBodyType>(
    `v2/app-discounts/sync`
  );
  return resp.data;
};
export const useSyncAppDiscountFunctions = () => {
  return useMutation<SyncFunctionCampaignsResponseBodyType, Error>({
    mutationKey: ["syncFunctionCampaigns"],
    mutationFn: async () => syncAppDiscountFunctions(),
    onSuccess: (data) => {
      if (data.deployed) toast.success("function synced!");
      else toast.error("error syncing function");
    },
  });
};
